import React from 'react';
import { FaWifi, FaPrint } from 'react-icons/fa';

const TransactionReceipt = ({ transaction }) => {
  if (!transaction) return null;

  const handlePrint = () => {
    window.print();
  };

  const networkName = typeof transaction.network === 'string' 
    ? transaction.network 
    : transaction.network?.name 
      ? `${transaction.network.name} ${transaction.network?.code ? `(${transaction.network.code})` : ''}` 
      : 'N/A';

  const dateString = transaction.timestamp 
    ? (transaction.timestamp.toDate 
        ? transaction.timestamp.toDate().toLocaleString() 
        : (transaction.timestamp.seconds 
            ? new Date(transaction.timestamp.seconds * 1000).toLocaleString() 
            : new Date(transaction.timestamp).toLocaleString())) 
    : 'N/A';

  return (
    <div className='bg-light2 dark:bg-dark1 text-dark0 dark:text-light1 space-y-6 w-full py-4 px-8 rounded-md printable-receipt'>
      <div className='flex flex-col items-center justify-center space-y-2 mb-4'>
        <div className='flex items-center text-2xl font-bold'>
            <FaWifi className='text-primary mx-2' />
            <span className='text-primary'>Jcoteck VTU</span>
        </div>
        <h2 className='text-primary bg-light1 dark:bg-dark2 px-8 py-1 rounded-2xl'>Transaction Receipt</h2>
        <hr className='border-dark0 w-full' />
      </div>

      <div className='space-y-4 text-sm md:text-base'>
        <div className='flex justify-between border-b border-dark0 pb-2'>
            <span className='font-semibold'>Reference ID:</span>
            <span>{transaction.id}</span>
        </div>
        <div className='flex justify-between border-b border-dark0 pb-2'>
            <span className='font-semibold'>Date:</span>
            <span>{dateString}</span>
        </div>
        <div className='flex justify-between border-b border-dark0 pb-2'>
            <span className='font-semibold'>Type:</span>
            <span className='capitalize'>{transaction.type}</span>
        </div>
        <div className='flex justify-between border-b border-dark0 pb-2'>
            <span className='font-semibold'>Network:</span>
            <span>{networkName}</span>
        </div>
        <div className='flex justify-between border-b border-dark0 pb-2'>
            <span className='font-semibold'>Phone Number:</span>
            <span>{transaction.mobileNumber || 'N/A'}</span>
        </div>
        <div className='flex justify-between border-b border-dark0 pb-2'>
            <span className='font-semibold'>Amount:</span>
            <span>₦{transaction.amount}</span>
        </div>
        <div className='flex justify-between border-b border-dark0 pb-2'>
            <span className='font-semibold'>Status:</span>
            <span className={`capitalize ${transaction.response?.status === 'successful' || transaction.response?.status === 'success' ? 'text-green-500' : 'text-red-500'}`}>
                {transaction.response?.status || 'N/A'}
            </span>
        </div>
      </div>

      <div className='flex justify-around pt-4 no-print'>
        <button onClick={handlePrint} className='flex items-center btn text-dark0 px-4 py-2 rounded-md hover:opacity-90'>
            <FaPrint className='mr-2' /> Print Receipt
        </button>
      </div>
    </div>
  );
};

export default TransactionReceipt;
